import { render, staticRenderFns } from "./secondCard.vue?vue&type=template&id=33246cc7&scoped=true"
import script from "./secondCard.vue?vue&type=script&lang=js"
export * from "./secondCard.vue?vue&type=script&lang=js"
import style0 from "./secondCard.vue?vue&type=style&index=0&id=33246cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33246cc7",
  null
  
)

export default component.exports